import React from 'react';
import Features from './Features';
import Advantages from './Advantages';
import { FAQ } from '../FAQ/faqs';
import Footer from '../Footer';


function WebsiteBuilder() {
  return (
    <>
<Features docname="Website Builder"/>
<Advantages docname="Website Builder"/>
<FAQ category="About Accxchange"/>
<Footer segment="Smarty Home"/>
    </>
  );
}

export default WebsiteBuilder;
